export enum AppointmentStatus {
  Created = 'created',
  Scheduled = 'scheduled',
  InProgress = 'in_progress',
  Done = 'done',
  Canceled = 'canceled',
  Rescheduled = 'rescheduled',
}

export enum CalendarViewModeEnum {
  Day = 'day',
  Week = 'week',
  Month = 'month',
}


